import React from 'react';
import PropTypes from 'prop-types';

import { TextStyled } from './styles';

export function Text(props) {
	const { paddingLeft, size, weight, color, center, className, children, ...rest } = props;
	return (
		<TextStyled
			{...rest}
			className={className}
			size={size}
			color={color}
			weight={weight}
			center={center}
			paddingLeft={paddingLeft}>
			{children}
		</TextStyled>
	);
}

Text.propTypes = {
	size: PropTypes.string,
	className: PropTypes.string,
	color: PropTypes.string,
	weight: PropTypes.string,
	center: PropTypes.bool,
	children: PropTypes.oneOfType([PropTypes.any]),
};

Text.defaultProps = {
	size: 'default',
	color: 'default',
	weight: 'default',
	center: false,
	className: '',
	children: undefined,
};
